import { render, staticRenderFns } from "./AddBlockToCurrentBlocksPanel.vue?vue&type=template&id=534c5897&"
import script from "./AddBlockToCurrentBlocksPanel.vue?vue&type=script&lang=js&"
export * from "./AddBlockToCurrentBlocksPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports